import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { getGeneratedAppUrl } from '../actions/applifecycle.actions';
import {
  generateBECode,
  generateBECodeStatus,
  getPushStatus,
  pullCodeFromGit,
  pulledCodeFromGit,
  pushCodeToGit,
  pushedCodeToGit,
  syncedToGit,
  syncToGit
} from '../actions/codegeneration.actions';
import { UtilService } from 'src/app/services/util.service';

@Injectable()
export class CodeGenEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private utilService = inject(UtilService);

  public static pushStatusTimeout: any;

  generateCode$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(generateBECode),
        map((action: any) => {
          return this.baseService[action.genBECodeApi?.method](action.genBECodeApi, action.genBECodeApi).subscribe(
            (_beCodeGenStatus: any) => {
              this.store.dispatch(generateBECodeStatus({ beCodeGenStatus: 'success' }));

              this.store.dispatch(
                getGeneratedAppUrl({
                  apiConstants: action.genBECodeApi,
                  sid: action.genBECodeApi.appId
                })
              );
            },
            (error: any) => {
              this.store.dispatch(generateBECodeStatus({ beCodeGenStatus: error }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  pushCodeToGit$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(pushCodeToGit),
        map((action: any) => {
          this.utilService.setGitError(false);
          return this.baseService[action.pushToGitApi?.method](
            action.pushToGitApi,
            action.pushToGitApi.params
          ).subscribe(
            (gitCommitStatus: any) => {
              this.store.dispatch(
                getPushStatus({ gitStatusApi: ApiConstants.pushCodetoGitPolling, gitParams: gitCommitStatus })
              );
              this.store.dispatch(pushedCodeToGit({ gitCommitStatus: gitCommitStatus }));
            },
            (error: any) => {
              this.utilService.setGitError(true);
              this.store.dispatch(pushedCodeToGit({ gitCommitStatus: error }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  pullCodeFromGit$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(pullCodeFromGit),
        map((action: any) => {
          this.utilService.setGitError(false);
          return this.baseService[action.pullFromGitApi?.method](
            action.pullFromGitApi,
            action.pullFromGitApi.params
          ).subscribe(
            (_gitPullStatus: any) => {
              this.store.dispatch(pulledCodeFromGit({ gitPullStatus: 'success' }));
            },
            (error: any) => {
              this.utilService.setGitError(true);
              this.store.dispatch(pulledCodeFromGit({ gitPullStatus: error }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  syncToGit$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(syncToGit),
        map((action: any) => {
          return this.baseService[action.syncToGitApiConstants?.method](
            action.syncToGitApiConstants,
            action.syncToGitApiConstants.params
          ).subscribe(
            (syncToGitStatus: any) => {
              this.store.dispatch(
                getPushStatus({ gitStatusApi: ApiConstants.pushCodetoGitPolling, gitParams: syncToGitStatus })
              );
            },
            (error: any) => {
              this.store.dispatch(syncedToGit({ syncToGitStatus: error }));
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getPushStatus$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getPushStatus),
        map((action: any) => {
          return this.baseService[action.gitStatusApi?.method](action.gitStatusApi, action.gitParams).subscribe(
            (pushStatus: any) => {
              if (
                pushStatus &&
                pushStatus.status !== 'GIT_PUSH_COMPLETED' &&
                pushStatus.status !== 'GIT_SYNC_COMPLETED'
              ) {
                CodeGenEffects.pushStatusTimeout = setTimeout(() => {
                  this.store.dispatch(
                    getPushStatus({ gitStatusApi: ApiConstants.pushCodetoGitPolling, gitParams: action.gitParams })
                  );
                }, 10000);
              } else {
                this.store.dispatch(pushedCodeToGit({ gitCommitStatus: 'success' }));
                this.store.dispatch(syncedToGit({ syncToGitStatus: 'success' }));
                clearTimeout(CodeGenEffects.pushStatusTimeout);
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
}
